/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import AppConfig from '../../AppConfig';
import FrontAPI from '../app/FrontAPI';
import { firebaseErrorLogger } from '../app/firebaseErrorLogger';
import _set from "lodash/set";
import { DataType, IPropsTimecode } from '../IFormularios';
import { ITablePaginacao, Order } from '../../componentes/tabelas/ITabelas';
import { IPropsFilterObj } from '../../componentes/tabelas/TableFilter';
import { isUndefined } from 'lodash';

interface UploadResult {
    filename: string;
    success: boolean;
    error?: string;
}

export interface IProgramasData
{
    idPrograma?: number|undefined
    idSerie?: number|undefined
    idRepositorio?: number|undefined
    escaninho?: string|undefined|null
    titulo?: string|undefined|null
    tituloOriginalSerie?: string|undefined|null
    tituloOriginalPrograma?: string|undefined|null
    nomeEpisodio?: string|undefined|null
    tipoMidia?: number|undefined
    tipoPrograma?: number|undefined
    idGsatIdFrm?: string|undefined|null
    dataExibicao?: string|undefined|null
    dataVencimento?: string|undefined|null
    qtdExibicoes?: string|undefined|null
    prazo?: string|undefined|null
    restricaoExibicao?: string|undefined|null
    vigencia?: number|undefined
    apresentador?: string|undefined|null,
    consultoria?: string|undefined|null
    edicao?: string|undefined|null
    direcao?: string|undefined|null
    elenco?: string|undefined|null
    entrevistado?: string|undefined|null
    fotografia?: string|undefined|null
    licenciamento?: number|undefined,
    listaMusica?: string|undefined|null
    narrador?: string|undefined|null
    producao?: string|undefined|null
    restricoes?: string|undefined|null
    roteiro?: string|undefined|null
    trilhaOriginal?: string|undefined|null
    anoLicenca?: string|undefined|null
    anoProducao?: string|undefined|null
    anoProducaoInicial?: string|undefined|null
    anoProducaoFinal?: string|undefined|null
    aoVivo?: null,
    aquisicao?: null,
    classificacaoEtaria?: number|undefined,
    distribuidor?: "",
    duracao?: string|undefined|null
    baseLimpa?: string|undefined|null
    qtdBlocos?: string|undefined|null
    numeroEpisodio?: string|undefined|null
    ancineOficioDezembro2013?: string|undefined|null
    palavraChave?: string|undefined|null
    possuiAudioME?: string|undefined|null
    possuiClosedCaption?: string|undefined|null
    sinopse?: string|undefined|null
    autor?: string|undefined|null
    consultoriaRoteiro?: string|undefined|null
    observacoesGerais?: string|undefined|null
    idiomaVersao?: string|undefined|null
    sinopseIdioma?: string|undefined|null
    timecodeLegado?: string|undefined|null
    timecodes?: IPropsTimecode[]|[]
    anexos?: IPropsTimecode[]|[]
    autorizacoes?: IPropsTimecode[]|[]
    planilhasMusicais?: IPropsTimecode[]|[]
    materiaisDivulgacao?: IPropsTimecode[]|[]
    recursosAcessibilidade?: IPropsTimecode[]|[]
    anexosOutros?: IPropsTimecode[]|[]
    versao?: string|undefined|null
    idQuemCadastrou?: string|undefined|null
    idQuemAlterou?: string|undefined|null
    dataCadastro?: string|undefined|null
    dataAlteracao?: string|undefined|null
    rows?: IProgramasData[]
}   

export interface IRetornoAjaxProgramas
{
    Data: IProgramasData | null
    pager?: ITablePaginacao
    message?: string
    status?: number
}

export default class Programas_FrontAPI extends FrontAPI
{
    //#region PROGRAMA [LIST, CREATE, UPDATE, DELETE]

        public async programasListaAjax(token:string,idPrograma?:number,callbackDataFilter?:IPropsFilterObj,rowsNum?:number,pageNum?:number,orderBy?:string,order?:Order,sortParameter?:string) : Promise<null|IRetornoAjaxProgramas>
        {
            const url = AppConfig.API.programas.list;
            const header = {"Authorization" : "Bearer "+token}
            
            try
            {
                let qs = {};

                if(idPrograma) {
                    _set(qs, 'idPrograma', idPrograma);
                    _set(qs, 'anexoLink', '1');
                    _set(qs, 'programaVideo', '1');
                    // _set(qs, 'programaVideo', '1');
                }
                else
                {
                    if(rowsNum)
                        _set(qs, 'pageSize', rowsNum);
                    
                    if(pageNum)
                        _set(qs, 'pageNum', pageNum);

                    if(rowsNum)
                        _set(qs, 'orderBy', orderBy);
                    
                    if(pageNum)
                        _set(qs, 'order', order);

                    if(sortParameter)
                        _set(qs, 'sortParameter', sortParameter);

                    if(order)
                        _set(qs, 'sortDirection', order);


                    if(callbackDataFilter)            
                        for (const indiceFilter in callbackDataFilter)
                        {
                            if (callbackDataFilter.hasOwnProperty(indiceFilter))
                            {
                                _set(qs, indiceFilter, callbackDataFilter[indiceFilter]);
                            }
                        }   
                }
                    
                const res = await this.httpGet(url, header, qs, undefined)
                
                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {              
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }
        
        public async programaCreateAjax(token:string,data:FormData) : Promise<null|IRetornoAjaxProgramas>
        {
            const url = AppConfig.API.programas.create;
            const header = {"Authorization" : "Bearer "+token, "Content-Type": "multipart/form-data"}  

            try
            {
                const res = await this.httpPost(url, data, header, undefined);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }

        public async programaUpdateAjax(token: string, data: FormData, tipo: DataType): Promise<IRetornoAjaxProgramas> {
            
            if (tipo === DataType.ANEXOS) {
                try {
                    const anexos = JSON.parse(data.get('anexos') as string);
                    
                    const idPrograma = JSON.parse(data.get('idPrograma') as string);
                    const url = `${AppConfig.API.programas.list}?idPrograma=${idPrograma}&anexoLink=1`;
                    
                    const header = {"Authorization" : `Bearer ${token}`};
                    const programaRes = await this.httpGet(url, header);
                    
                    if (!programaRes?.data?.Data) {
                        console.error('[programaUpdateAjax] Failed to get programa data');
                        throw new Error("Não foi possível obter os links de upload");
                    }
        
                    const programa = programaRes.data.Data;
                    
                    const uploadResults: UploadResult[] = [];
                    const errors: string[] = [];

                    for (let i = 0; i < anexos.length; i++) {
                        const fileField = data.get(`anexo.${i}.arquivo`) as File | null;
                        
                        if (fileField) {
                            const anexo = anexos[i];
                            
                            const capitalizedTipo = anexo.tipo
                                .split('-')
                                .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
                                .join('');
                            
                            const linkKey = `linkAnexo${capitalizedTipo}Upload`;
                            const folderInfo = programa[linkKey];
                            
                            let fileUploadUrl = null;
                            let fileTypeParam = null;
                            let signedUrlResponse = null;

                            if (folderInfo?.path && folderInfo?.bucket) {
                                try {
                                    if (AppConfig.Firebase.StorageEmulator) {
                                        const emulatorHost = AppConfig.Firebase.StorageEmulatorHost;
                                        const uploadEmulatorUrl = `http://${emulatorHost}/v0/b/${folderInfo.bucket}/o/${encodeURIComponent(`${folderInfo.path}/${anexo.nome}`)}?uploadType=media`;
                                        const response = await fetch(uploadEmulatorUrl, {
                                            method: 'POST',
                                            body: fileField,
                                            headers: {
                                                'Content-Type': fileField.type || 'application/octet-stream'
                                            }
                                        });
        
                                        if (!response.ok) {
                                            let responseBody = '';
                                            try {
                                                responseBody = await response.text();
                                            } catch (e) {
                                                responseBody = '[Unable to read response body]';
                                            }
                                            firebaseErrorLogger(errors, 'programaUpdateAjax_anexos_uploadEmulator', {
                                                responseBody: responseBody
                                            });
                                            throw new Error(`HTTP error! status: ${response.status}`);
                                        }
                                    } else {
                                        fileTypeParam = encodeURIComponent(`${fileField.type}` || 'application/octet-stream');
                                        fileUploadUrl = `${AppConfig.API.util.getUploadUrl}?action=getUploadUrl&bucket=${folderInfo.bucket}&fileType=${fileTypeParam}&path=${encodeURIComponent(`${folderInfo.path}/${anexo.nome}`)}`;
                                        
                                        signedUrlResponse = await this.httpGet(fileUploadUrl, header);

                                        if (!signedUrlResponse?.data?.Data?.url) {
                                            console.error('[programaUpdateAjax] Failed to get signed URL');
                                            throw new Error('Failed to get signed URL for upload');
                                        }

                                        const response = await fetch(signedUrlResponse?.data?.Data?.url, {
                                            method: 'PUT',
                                            body: fileField,
                                            headers: {
                                                'Content-Type': fileField.type || 'application/octet-stream'
                                            }
                                        });
        
                                        if (!response.ok) {
                                            let responseBody = '';
                                            try {
                                                responseBody = await response.text();
                                            } catch (e) {
                                                responseBody = '[Unable to read response body]';
                                            }
                                            firebaseErrorLogger(errors, 'programaUpdateAjax_anexos_signedUrl', {
                                                responseBody: responseBody
                                            });
                                            throw new Error(`HTTP error! status: ${response.status}`);
                                        }
                                    }
        
                                    uploadResults.push({
                                        filename: anexo.nome,
                                        success: true
                                    });
                                } catch (error) {

                                    let additionalData = {
                                        tipo: JSON.stringify(tipo),
                                        idPrograma: data.get('idPrograma'),
                                        anexo: JSON.stringify(anexo),
                                    } as any;

                                    if(fileUploadUrl) {
                                        additionalData.fileUploadUrl = JSON.stringify(fileUploadUrl);
                                    }

                                    if(fileTypeParam) {
                                        additionalData.fileTypeParam = JSON.stringify(fileTypeParam);
                                    }

                                    firebaseErrorLogger(error, 'programaUpdateAjax_anexo', additionalData);

                                    console.error('[programaUpdateAjax] Error during file upload:', error);
                                    const errorMessage = error instanceof Error ? error.message : String(error);
                                    errors.push(`Erro ao fazer upload do arquivo ${anexo.nome}: ${errorMessage}`);
                                    uploadResults.push({
                                        filename: anexo.nome,
                                        success: false,
                                        error: errorMessage
                                    });
                                }
                            } else {
                                console.error('[programaUpdateAjax] Missing folder info for anexo:', anexo);
                                errors.push(`Informações de pasta não disponíveis para o arquivo ${anexo.nome} do tipo ${anexo.tipo}`);
                                uploadResults.push({
                                    filename: anexo.nome,
                                    success: false,
                                    error: 'Informações de pasta não disponíveis'
                                });
                            }
                        }
                    }
        
                    if (errors.length > 0) {
                        console.error('[programaUpdateAjax] Errors during upload:', errors);
                        throw new Error(`Erros durante o upload:\n${errors.join('\n')}`);
                    }

                    const metadataUrl = AppConfig.API.anexos.programa;
                    const metadataHeader = {"Authorization" : `Bearer ${token}`, "Content-Type": "multipart/form-data"};
                    const metadataBody = {
                        idPrograma,
                        anexos: anexos.map((anexo: any) => ({
                            ...anexo,
                            uploadStatus: uploadResults.find(r => r.filename === anexo.nome)?.success ? 'success' : undefined
                        }))
                    };

                    const metadataRes = await this.httpPost(metadataUrl, metadataBody, metadataHeader);
        
                    if (metadataRes.status === 200 || metadataRes.status === 201) {
                        return {
                            Data: null,
                            status: 200,
                            message: uploadResults.every(r => r.success) 
                                ? "Anexos atualizados com sucesso."
                                : `Alguns anexos foram atualizados com sucesso, mas houve ${errors.length} erro(s)`
                        };
                    } else {
                        throw new Error("Erro ao salvar metadados dos anexos");
                    }
        
                } catch(error) {
                    console.error('[programaUpdateAjax] Error in ANEXOS processing:', error);
                    const errorMessage = error instanceof Error ? error.message : String(error);
                    if(typeof errorMessage === "string") {
                        return {
                            Data: null,
                            status: 400,
                            message: this.traduzirMensagemErro(errorMessage),
                        };
                    }
                    return error as IRetornoAjaxProgramas;
                }
            } else {
                const url = AppConfig.API.programas.update;
                const header = {"Authorization" : `Bearer ${token}`, "Content-Type": "multipart/form-data"}
        
                try {
                    const res = await this.httpPut(url, data, header);
        
                    if(res.status && (res.status == 200 || res.status == 201)) {
                        let retorno = res.data;
                        retorno.status = 200;
                        return retorno;
                    } else {
                        let retorno = res.data;
                        retorno.status = 400;
                        return retorno;
                    }
                } catch(error) {
                    const errorMessage = error instanceof Error ? error.message : String(error);
                    if(typeof errorMessage === "string") {
                        return {
                            Data: null,
                            status: 400,
                            message: this.traduzirMensagemErro(errorMessage),
                        };
                    }
                    return error as IRetornoAjaxProgramas;
                }
            }
        }

        public async programaDeleteAjax(token:string,idPrograma:string) : Promise<undefined|IRetornoAjaxProgramas>
        {
            const url = AppConfig.API.programas.delete+'?idPrograma='+idPrograma;
            const header = {"Authorization" : "Bearer "+token}

            try
            {
                const res = await this.httpDelete(url, null, header);

                if(res.status && (res.status == 200 || res.status == 201))
                {
                    let retorno = res.data;

                    retorno.status = 200;

                    return retorno;
                }
                else
                {
                    let retorno = res.data;

                    retorno.status = 400;

                    return retorno;
                }
            }
            catch(e)
            {
                if(typeof e === "string") {
                    let retorno = {
                        Data: null,
                        status: 400,
                        message: this.traduzirMensagemErro(e),
                    };
                    return retorno;
                }
                return e;
            }
        }
    
    //#endregion
}